__turbopack_context__.v({
  "message": "ListingMessage-module-scss-module__pX8h_W__message",
  "message__actions": "ListingMessage-module-scss-module__pX8h_W__message__actions",
  "message__body": "ListingMessage-module-scss-module__pX8h_W__message__body",
  "message__heading": "ListingMessage-module-scss-module__pX8h_W__message__heading",
});
